import { Stack } from '@mui/material';
import { Contract } from '@vy/types';
import { FC, useCallback } from 'react';
import { getParentAgreementDetailItems } from '../utils/contract-utils';
import { useVyNavigate } from '../../../../../hooks/use-vy-navigate';
import { ParentAgreementCustomerDetails } from './ParentAgreementCustomerDetails';

type ParentAgreementDetailsProps = {
  contract: Contract;
};

export const ParentAgreementDetails: FC<ParentAgreementDetailsProps> = ({ contract }) => {
  const navigate = useVyNavigate();

  const onCustomerClick = useCallback(() => {
    navigate(`/customers/${contract.customer.id}/overview`);
  }, [contract.customer.id, navigate]);

  const detailItems = getParentAgreementDetailItems(contract);

  return (
    <Stack
      direction="row"
      sx={{
        gap: '50px',
        flexWrap: "wrap"
      }}>
      {detailItems.map((details) => (
        <ParentAgreementCustomerDetails key={details.label} label={details.label} value={details.value} />
      ))}
      <ParentAgreementCustomerDetails
        label="Customer name"
        value={contract.customer.name}
        onClick={onCustomerClick}
      />
    </Stack>
  );
};
